import { client } from '@atlassian/rovo-content-bridge-api';

const CONFLUENCE_EDITOR_CLIENT_ID_PREFIX = 'confluence-editor';

export const getConfluenceEditorClientId = (contentId: string) =>
	client(`${CONFLUENCE_EDITOR_CLIENT_ID_PREFIX}-${contentId}`);
